// TODO: css
import "./partneragreementsuccess.css";
import "./partneragreementform.css";
import "./page.css";



// WEBPACK FOOTER //
// ./src/modules/PartnerAgreement/assets/css/index.js